import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { Field, reduxForm } from "redux-form";
import { toast } from "react-toastify";

import { Button } from "../components/Form";

import { required, email } from "../lib/validation";

import { renderInput } from "../components/Form";

import { resetPassword } from "../auth/actions";

class ResetPasswordForm extends Component {
  submit = async values => {
    const { resetPassword, reset } = this.props;

    return resetPassword(values).then(() => {
      reset();
      toast.success("Dalsze informacje zostały wysłane na podany adres email");
    });
  };

  render() {
    const { handleSubmit, submitting, submitSucceeded } = this.props;
    return (
      <Form onSubmit={handleSubmit(this.submit)}>
        <Field
          name="email"
          component={renderInput}
          type="text"
          placeholder="Email"
          validate={[required, email]}
        />

        {submitSucceeded && (
          <Success>
            Dalsze instrukcje zostały wysłane na podany adres email
          </Success>
        )}

        <Button loading={submitting} color="primary" type="submit">
          Resetuj hasło!
        </Button>
      </Form>
    );
  }
}
const Success = styled.div.attrs({ className: "text-success" })`
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 20px;
  text-align: center;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  width: 300px;
  margin: 40px 0;

  @media (max-width: 400px) {
    width: 100%;
  }
`;

ResetPasswordForm = reduxForm({
  form: "resetPasswordForm"
})(ResetPasswordForm);

ResetPasswordForm = connect(null, { resetPassword })(ResetPasswordForm);

export default ResetPasswordForm;



// WEBPACK FOOTER //
// ./src/auth/ResetPasswordForm.js